import { STEP_STATUS } from '../Stepper.types';

export type StepStatusType = (typeof STEP_STATUS)[keyof typeof STEP_STATUS];

export const setProperStepStatus = (
    stepNumber: number,
    activeStep: number,
): StepStatusType => {
    if (stepNumber < activeStep) {
        return STEP_STATUS.Checked;
    } else if (stepNumber === activeStep) {
        return STEP_STATUS.Active;
    } else {
        return STEP_STATUS.Coming;
    }
};
